import {atom, useAtomValue, useSetAtom} from 'jotai';
import {useEffect, useId} from 'react';

const mapScrollAtom = atom<string>('');

export const useOverlayScroll = (offMapWheelScroll: boolean) => {
  const uid = useId();
  const setScrollUid = useSetAtom(mapScrollAtom);

  useEffect(() => {
    if (offMapWheelScroll) {
      setScrollUid(uid);
    } else {
      setScrollUid((prev) => (prev === uid ? '' : prev));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offMapWheelScroll]);

  useEffect(() => {
    return () => {
      setScrollUid((prev) => (prev === uid ? '' : prev));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const usePreventMapScrollEvent = () => {
  const preventScrollElementId = useAtomValue(mapScrollAtom);

  return !!preventScrollElementId?.length;
};
